import React from 'react';
import { Button } from 'semantic-ui-react';

const FeedList = ({ history, requests, morePages, loadMore }) => {
    return (
        <div>
            {(!requests || !requests.length) && <div className="no-invites">There are currently no items in your feed</div>}
            {requests &&
                !!requests.length &&
                requests.map(
                    ({
                        _id,
                        type,
                        activityType,
                        activityTypeIcon,
                        ActivitySlots,
                        activityTime,
                        Status,
                        Facility,
                        AcceptedBy = '',
                        AcceptedByName = '',
                        ClosedByName = '',
                        RequestedTime,
                        Name,
                        RequestType_Name,
                        RequestType_Icon,
                        RequestSlots = {Message: ''},
                        Registrant_FirstName,
                        Registrant_LastName,
                        Registrant_Image,
                        registrantFirstName,
                        registrantLastName,
                        registrantImage,
                    }) => {
                        return type === 'request' ? (
                            <div
                                className="activity-container"
                                key={_id}
                                role="link"
                                onClick={() => {
                                    history.push(`/requests/${_id}`);
                                }}
                            >
                                <div className="resident-image-section">
                                    {Registrant_Image ? (
                                        <img className="resident-image" src={Registrant_Image} alt="" />
                                    ) : (
                                        <img className="resident-image" src='/avatar_placeholder.png' alt="" />
                                    )}
                                </div>
                                <div className="flex-1">
                                    <div className="title">{`${Registrant_FirstName} ${Registrant_LastName}`}</div>
                                    <span className="timestamp">
                                        {new Date(RequestedTime).toLocaleString()}
                                        {RequestType_Name !== 'Greetings' && <span className="status">{Status}</span>}
                                    </span>
                                    
                                    {(Name === "Message") && RequestSlots.Message ? 
                                        <div className="title">{RequestSlots.Message}</div>
                                    : 
                                        <div className="title">{Name}</div>
                                    }
                                </div>
                                <div className="icon-section">
                                    {RequestType_Icon && <img src={RequestType_Icon} alt="" />}
                                </div>
                            </div>
                        ) : (
                            <div
                                className="activity-container"
                                role="link"
                                onClick={() => {
                                    history.push(`/activities/${_id}`);
                                }}
                                key={_id}
                            >
                                <div className="resident-image-section">
                                    {registrantImage ? <img className="resident-image" src={registrantImage} alt="" /> : <img className="resident-image" src='/avatar_placeholder.png' alt="" />}
                                </div>
                                <div className="flex-1">
                                    <div className="title">{`${registrantFirstName} ${registrantLastName}`}</div>
                                    <div className="timestamp">{new Date(activityTime).toLocaleString()}</div>

                                    <div className="title">{Name}</div>
                                </div>
                                <div className="icon-section">
                                    {activityTypeIcon && <img src={activityTypeIcon} alt="" />}
                                </div>
                            </div>
                        );
                    },
                )}
            {morePages && (
                <div className="pagination">
                    {
                        <Button className="basic tiny primary" onClick={loadMore}>
                            Load More
                        </Button>
                    }
                </div>
            )}
        </div>
    );
};

export default FeedList;
